import { useQuery } from '@tanstack/react-query';
import { getTenantSettings, TENANT_SETTINGS_QUERY_KEY } from '../services/tenantSettings/tenantSettingsService';

/**
 * Tenant settings from React Query cache. Prefetched on login and when the app loads (RequireAuth),
 * so components use the same cached settings for logic (e.g. weighing lookup display, commodity/driver filters).
 */
export function useTenantSettings() {
    return useQuery({
        queryKey: TENANT_SETTINGS_QUERY_KEY,
        queryFn: ({ signal }) => getTenantSettings(signal),
        staleTime: Infinity,
        gcTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
}
